import { Inject, Injectable } from '@angular/core';
import Web3, { Address } from 'web3';
import { environment } from 'src/environments/environment';
import { AlertService } from './alert.service';
import { SmartWalletService } from './smart-wallet.service';
declare let window: any;

@Injectable({
  providedIn: 'root',
})
export class Web3Service {
  private web3: Web3 | undefined;
  private provider: any;
  private metamaskDeepLinkSession: string = '';
  constructor(private alertService: AlertService, private smartWalletService: SmartWalletService) {
    this.initializeWeb3();
  }

  get web3Instance(): Web3 | undefined {
    if (this.web3) return this.web3;
    return;
  }

  private async initializeWeb3() {
    this.provider = new Web3.providers.HttpProvider(environment.rpcAddress);
    this.web3 = new Web3(this.provider);
  }

  async connectMetaMask(): Promise<Address[] | null> {
    if (typeof window.ethereum !== 'undefined') {
      try {
        this.web3 = new Web3(window.ethereum);
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        return accounts;
      } catch (error) {
        console.error('MetaMask connection error:', error);
        return null;
      }
    } else {
      try {
        await this.provider.connect();
        const web3 = new Web3(this.provider as any);
        const accounts = await web3.eth.getAccounts();
        if (accounts.length > 0) {
          return accounts;
        } else {
          alert('No accounts connected');
        }
      } catch (error) {
        console.error('Error during wallet connection:', error);
      }

      return null;
    }
  }

  public async signMessageWithMetaMask(message: string): Promise<string> {
    const ethereum = (window as any).ethereum;
    if (ethereum) {
      await window.ethereum.request({ method: 'eth_requestAccounts' });

      const web3 = new Web3(window.ethereum);

      const accounts = await web3.eth.getAccounts();
      const fromAddress = accounts[0];

      const signature = await web3.eth.personal.sign(message, fromAddress, '');
      return signature;
    } else if (this.web3) {
      const accounts = await this.web3.eth.getAccounts();
      window.location.href = this.metamaskDeepLinkSession;
      const signature = await this.provider.request({
        method: 'personal_sign',
        params: [message, accounts[0]],
      });
      return signature;
    } else {
      throw new Error('MetaMask nÃ£o estÃ¡ instalado');
    }
  }

  async getPointsBalance(address: string): Promise<any> {
    // Generico? passar contractName?
    if (!this.web3) {
      console.error('Web3 is not initialized');
      return '0';
    }
    try {
      const contractPoint = new this.web3.eth.Contract(environment.contracts.StarPoint.abi, environment.contracts.StarPoint.address);
      const balancePoint: number = await contractPoint.methods['balanceOf'](address).call();
      const ret = { points: parseInt(this.web3.utils.fromWei(balancePoint, 'ether')) };
      return ret;
    } catch (error) {
      console.error('Error fetching balance:', error);
      return '0';
    }
  }

  async getTokenBalance(address: string): Promise<any> {
    if (!this.web3) {
      console.error('Web3 is not initialized');
      return '0';
    }
    try {
      const contractToken = new this.web3.eth.Contract(environment.contracts.StarOFToken.abi, environment.contracts.StarOFToken.address);
      const balancePoint: number = await contractToken.methods['balanceOf'](address).call();
      const ret = { points: this.web3.utils.fromWei(balancePoint, 'ether') };
      return ret;
    } catch (error) {
      console.error('Error fetching balance:', error);
      return '0';
    }
  }

  async addWalletFromMetaMask(): Promise<string[] | null> {
    if (!this.web3) {
      console.error('Web3 is not initialized');
      return null;
    }
    try {
      await this.provider.request({
        method: 'wallet_requestPermissions',
        params: [{ eth_accounts: {} }],
      });
      const accounts = await this.provider.request({ method: 'eth_accounts' });

      console.log('Connected Wallets:', accounts);
      return accounts;
    } catch (error: any) {
      console.error('Error adding wallet:', error);
      this.alertService.errorAlert(error.message, 'Error');
      return null;
    }
  }

  public async disconnect(): Promise<void> {
    if (this.provider && this.web3) {
      try {
        this.provider = null;
        this.web3 = undefined;
      } catch (error) {
        console.error('Error disconnecting Web3 wallet:', error);
      }
    }
  }
}
